import { Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";
import ChunkErrorBoundary from "../common/ChunkErrorBoundary";
import TrialBanner from "../common/TrialBanner";
import Sidebar from "./Sidebar";

const PrivateRoutesSuspense = ({ children }) => {
  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);
  
  const location = useLocation();
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const schoolData = useSelector((state) => state?.authSlice?.schoolDetail);
  
  const isTrialDisabled = schoolData?.isTrial && userData?.role === "School";
  
  const blockedPrefixes = [
    "/dashboard",
    "/students",
    "/student-detail",
    "/parents",
    "/parent-detail",
    "/classes",
    "/class-detail",
    "/collections",
    "/collection-detail",
    "/manage-admin",
    "/admin-detail",
    // "/likes",
    // "/my-likes"
  ];
  
  const isRouteBlocked = isTrialDisabled && blockedPrefixes.some(prefix => location.pathname.startsWith(prefix));

  return (
    <>
      <div>
        <div className="main-wrap ">
          <div className={show ? "left-side hide" : "left-side "}>
            <Sidebar
              isActive={isActive}
              setIsActive={setIsActive}
              show={show}
              setShow={setShow}
            />
          </div>
          <div className="top-fix-sec">
            <ChunkErrorBoundary>
              <Suspense
                fallback={
                  <div className="loader-style container-fluid">
                    <FadeLoader
                      className="fade-loader"
                      loading={true}
                      color={"#D61F7F"}
                    />
                  </div>
                }
              >
                <div className={show ? "right-side-cmn hide" : "right-side-cmn "} style={{ paddingTop: schoolData?.isTrial && userData?.role === "School" ? '60px' : '0' }}>
                  {isRouteBlocked ? (
                    <>
                      {schoolData?.isTrial && userData?.role === "School" && (
                        <div className="top-fix-sec">
                          <div className="pt-2 d-flex">
                            <div style={{ width: '240px', flexShrink: 0 }} className="d-none d-lg-block"></div>
                            <div style={{ flexGrow: 1 }} className="pe-4 ps-3">
                              <TrialBanner />
                            </div>
                          </div>
                        </div>
                      )}
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh', textAlign: 'center' }}>
                        <div className="mb-4">
                        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" fill="#ff9800" fillOpacity="0.2"/>
                          <path d="M12 8V13" stroke="#ff9800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M11.9941 16H12.0031" stroke="#ff9800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <h2 className="mb-3 px-3" style={{ color: "var(--primary)", fontWeight: "600", wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", fontSize: "22px" }}>Not available during your trial</h2>
                      <p className="mb-4 px-3" style={{ color: "#666", maxWidth: "500px", margin: "0 auto", wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", fontSize: "14px" }}>
                        This page is not available in the trial version. Please Convert your account to an Organisation to unlock this and many other features!
                      </p>
                    </div>
                    </>
                  ) : (
                    children || <Outlet />
                  )}
                </div>
              </Suspense>
            </ChunkErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivateRoutesSuspense;
